export default __webpack_public_path__ + "static/media/navjeet.a1260109.jpg";